<div class="m-5 md:m-15 grid grid-cols-12 gap-4 place-content-center">
  <p-card
    header="Login"
    class="col-span-12 lg:col-span-8 lg:col-start-3 xl:col-span-4 xl:col-start-5"
  >
    <form #loginForm="ngForm" (ngSubmit)="onSubmit()">
      <p-fluid class="grid gap-4">
        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-user"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <input
              pInputText
              id="username"
              name="username"
              type="text"
              [(ngModel)]="user.username"
              required
              #username="ngModel"
              [invalid]="
                username.invalid && (username.touched || loginForm.submitted)
              "
            />

            <label for="username">Username</label>
          </p-floatlabel>
        </p-inputgroup>
        @if (username.invalid && (username.touched || loginForm.submitted)) {
        <p-message severity="error" size="small" variant="simple"
          >Username is required.</p-message
        >
        }

        <p-inputgroup>
          <p-inputgroup-addon>
            <i class="pi pi-lock"></i>
          </p-inputgroup-addon>
          <p-floatlabel variant="on">
            <p-password
              id="password"
              name="password"
              [(ngModel)]="user.password"
              autocomplete="off"
              required
              #password="ngModel"
              [feedback]="false"
              [invalid]="
                password.invalid && (password.touched || loginForm.submitted)
              "
              [toggleMask]="true"
            />

            <label for="password">Password</label>
          </p-floatlabel>
        </p-inputgroup>
        @if (password.invalid && (password.touched || loginForm.submitted)) {
        <p-message severity="error" size="small" variant="simple"
          >Password is required.</p-message
        >
        } @if (loginForm.submitted && errorMessage !== undefined) {
        <p-message severity="error" size="small" variant="simple">{{
          errorMessage
        }}</p-message>
        }

        <button
          pButton
          type="submit"
          label="Login"
          [disabled]="username.invalid || password.invalid || isLoading"
        ></button>
        <p-divider />
      </p-fluid>
    </form>
  </p-card>
</div>
